<template>
  <div>
  <div class="hello">
    <div class="form-group">
      <label for="date">Data</label><br/>
      <input id="date" name="date" v-model="date"><br/>
    </div>
    <div class="form-group">
      <label for="cinema">ID kina</label><br/>
      <input id="cinema" name="cinema" v-model="cinema"><br/>
    </div>
    <div class="form-group">
      <label for="max-break">Maksymalna przerwa</label><br/>
      <input id="max-break" name="max-break" type="number" v-model="maxBreak"><br/>
    </div>
    <button @click="getMovies">
      Pobierz filmy
    </button>
  </div>
    <div>
      <div v-bind:key="film.id" v-for="(film,index) in films"><input type="checkbox" v-model="films[index].selected" :value="index">{{ film.name }} ({{ film.length }} min/{{ film.length + 20}} min)</div>
      <button @click="calculate" v-if="films.length > 0">Oblicz</button>
    </div>
    <div>
      <div class="margin-bottom" v-bind:key="index" v-for="(pair,index) in result"> ({{minsToHour(pair.event1.start)}}) {{titles[pair.event1.filmId]}} ({{minsToHour(pair.event1.end)}}) - {{pair.movieBreak}} min. przerwy - ({{minsToHour(pair.event2.start)}}) {{titles[pair.event2.filmId]}} ({{minsToHour(pair.event2.end)}})</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

function sortPair (a, b) {
  return a.movieBreak - b.movieBreak
}

export default {
  name: 'CinemaForm',
  data () {
    return {
      date: '2022-03-12',
      cinema: '1081',
      maxBreak: '0',
      films: [],
      events: [],
      result: [],
      titles: []
    }
  },
  methods: {
    getMovies: function () {
      const vm = this
      vm.result = []
      axios
        .get('http://localhost:8080/' + vm.date + '.json')
        .then(response => {
          vm.films = response.data.body.films
          vm.events = response.data.body.events
        })
    },
    calculate () {
      const vm = this
      vm.result = []
      let selected = null
      selected = []
      let events = null
      events = []
      let pairs = null
      pairs = []
      let titles = null
      titles = {}
      let lengths = null
      lengths = {}
      vm.films.forEach(film => {
        titles[film.id] = film.name
        lengths[film.id] = film.length
      })
      this.films.forEach((film) => {
        if (film.selected) {
          selected.push(film.id)
        }
      })
      console.log(selected)
      this.events.forEach(event => {
        if (selected.includes(event.filmId)) {
          event.start = vm.calcDateToMins(event.eventDateTime)
          console.log(vm.minsToHour(event.start))
          event.end = vm.calcDateToMins(event.eventDateTime) + lengths[event.filmId] + 20
          console.log(vm.minsToHour(event.end))
          console.log(event.start)
          events.push(event)
        }
      })
      events.forEach(event1 => {
        events.forEach(event2 => {
          if (event1.filmId !== event2.filmId && event1.end < event2.start && (parseInt(vm.maxBreak) === 0 || (event2.start - event1.end) < vm.maxBreak)) {
            pairs.push({ event1: event1, event2: event2 })
          }
        })
      })
      pairs.forEach(pair => {
        pair.movieBreak = pair.event2.start - pair.event1.end
      })
      pairs.sort(sortPair)
      vm.result = pairs
      vm.titles = titles
      console.log(pairs)
    },
    calcDateToMins: function (date) {
      const datetime = new Date(date)
      return datetime.getHours() * 60 + datetime.getMinutes()
    },
    minsToHour: function (mins) {
      let m = mins % 60
      if (m < 10) {
        m = '0' + m
      }
      let h = (mins - (mins % 60)) / 60
      if (h < 10) {
        h = '0' + h
      }
      return h + ':' + m
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.form-group {
  margin-bottom: 10px;
}
div {
  text-align: left;
}
.margin-bottom{
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
